import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RichBlock, RichBlockActionActivation } from '@pure1/data';
import { ActionsBlockComponent } from './actions-block/actions-block.component';
import { CalloutBlockComponent } from './callout-block/callout-block.component';
import { ChartBlockComponent } from './chart-block/chart-block.component';
import { SelectBlockComponent } from './select-block/select-block.component';
import { StatListBlockComponent } from './stat-list-block/stat-list-block.component';
import { TableBlockComponent } from './table-block/table-block.component';
import { TaskListBlockComponent } from './task-list-block/task-list-block.component';

/**
 * Renders one rich block by dispatching on its `type`.
 *
 * An unrecognised type renders nothing and does not throw, so a client that predates a block type
 * degrades silently — which is why the seven-type union is deliberately not matched exhaustively.
 * All seven have a renderer now; the fall-through stays for the eighth.
 * Action activations are forwarded untouched.
 */
@Component({
    selector: 'copilot-rich-block',
    templateUrl: './rich-block.component.html',
    styleUrl: './rich-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [
        ActionsBlockComponent,
        CalloutBlockComponent,
        ChartBlockComponent,
        SelectBlockComponent,
        StatListBlockComponent,
        TableBlockComponent,
        TaskListBlockComponent,
    ],
})
export class RichBlockComponent {
    readonly block = input.required<RichBlock>();

    readonly activateAction = output<RichBlockActionActivation>();
}
